import { render, staticRenderFns } from "./GolfcourseMain.vue?vue&type=template&id=6f2571d1"
import script from "./GolfcourseMain.vue?vue&type=script&lang=js"
export * from "./GolfcourseMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports